import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import ScrollToTop from './utils/ScrollToTop';
import './App.css';

import HomePage from './pages/HomePage';
import InHouseDining from './pages/InHouseDining';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import TermsAndConditions from './pages/TermsAndConditions';
import Gallery from './pages/Gallery';
import Experiences from './pages/Experiences';

import ReturnAndRefundPolicy from './pages/ReturnAndRefundPolicy';
import BookNow from './pages/BookNow';
import RoomDetails from './RoomDetails';
import MainLayout from './components/layout/MainLayout';
import Attractions from './pages/Attractions';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // values from 0 to 3000, with step 50ms
      once: true, // whether animation should happen only once - while scrolling down
    });
  }, []);

  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/in-house-dining" element={<InHouseDining />} />
        <Route path="/rooms/:roomId" element={<RoomDetails />} />
        <Route path="/" element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="book-now" element={<BookNow />} />
          <Route path="terms-and-conditions" element={<TermsAndConditions />} />
          
          <Route path="return-and-refund-policy" element={<ReturnAndRefundPolicy />} />
          <Route path="attractions" element={<Attractions />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="experiences" element={<Experiences />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;